import { adminService } from '@/api/services';
import type { UnwrapData } from '@/api/types';

import type { IContactResponse, TContactPayload } from './types';

export const contactService = adminService.injectEndpoints({
  endpoints: (builder) => ({
    /**
     * Получить данные блока "Контакты"
     */
    getContact: builder.query<UnwrapData<IContactResponse>, { id: number }>({
      query: ({ id }) => ({
        method: 'GET',
        url: `/main_pages/${id}/contact`,
      }),
      transformResponse: (response: IContactResponse): UnwrapData<IContactResponse> => response.data,
      providesTags: ['MainPageContact'],
    }),
    /**
     * Создать данные блока "Контакты"
     */
    createContact: builder.mutation<UnwrapData<IContactResponse>, { id: number; data: TContactPayload }>({
      query: ({ id, data }) => ({
        method: 'POST',
        url: `/main_pages/${id}/contact`,
        body: {
          data,
        },
      }),
      transformResponse: (response: IContactResponse): UnwrapData<IContactResponse> => response.data,
      invalidatesTags: ['MainPage', 'MainPageContact'],
    }),
    /**
     * Обновить данные блока "Контакты"
     */
    updateContact: builder.mutation<UnwrapData<IContactResponse>, { id: number; data: TContactPayload }>({
      query: ({ id, data }) => ({
        method: 'PATCH',
        url: `/main_pages/${id}/contact`,
        body: {
          data,
        },
      }),
      transformResponse: (response: IContactResponse): UnwrapData<IContactResponse> => response.data,
      invalidatesTags: ['MainPageContact'],
    }),
  }),
});

export const { useGetContactQuery, useCreateContactMutation, useUpdateContactMutation } = contactService;
